module.exports = __webpack_public_path__ + "img/第7章_3-3_平行世界圖表2.jpg";